import { render, staticRenderFns } from "./inbound-recorded-answered-icon.vue?vue&type=template&id=a3a55dd2"
import script from "./inbound-recorded-answered-icon.vue?vue&type=script&lang=js"
export * from "./inbound-recorded-answered-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports